module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_1.f9e48c2d.pdf";